import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { Response } from "../interfaces/services/Response"

export const getRelatorioCancelamento = async (protocolo: string): Promise<string | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get(`Relatorio/GerarRelaTSolicExclUsr?protocolo=${protocolo}`, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      if (response?.data?.dados?.conteudo) resolve(response.data.dados.conteudo);
      reject(response);
    } catch (error: any) {
      reject(error.response);
    }
  })
};

export const getCartaDebitoAutomatico = async (): Promise<string | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes
        .get(`Relatorio/GerarRelatAutorizDebAut`,
          { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      if (response?.data?.dados?.conteudo) {
        resolve(response.data.dados.conteudo)
      } else {
        reject(response);
      }

    } catch (error: any) {
      reject(error.response);
    }
  })
}
export const getGerarRelatSaudeSuplementar = async (): Promise<Response | null> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes
        .get(`Relatorio/GerarRelatSaudeSuplementar`,
          { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      if (response?.data?.dados?.conteudo) {
        resolve(response)
      } else {
        reject(response);
      }

    } catch (error: any) {
      reject(error.response);
    }
  })
}

export const getRelatorioDeclaracaoPermanencia = (): Promise<string> => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await apiClientes.get('/Relatorio/GerarRelatDeclarPermanen',
        { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
      
      if (response?.data?.dados?.conteudo) {
        resolve(response.data.dados.conteudo);
      } else {
        reject('Não foi possível obter o relatório.')
      }
    } catch (error: any) {
      console.log({ error });
      reject(error);
    }
  })
}

export const gerarRelatSolicExclUsr = async (protocolo: string): Promise<Response> => {
  try {
    const response = await apiClientes.get(`/Relatorio/GerarRelaTSolicExclUsr`,
      { headers: { Authorization: `Bearer ${await getTokenClientes()}` }, params: { protocolo } });
    return response;
  } catch (error: any) {
    console.log({ error });
    return error.response;
  }
}